module.exports = __webpack_public_path__ + "static/media/hifi-08.4c51e06d.png";